module.exports = __webpack_public_path__ + "img/loading.9c98024f.svg";